import React from "react";
import * as S from "./styled";
import PT from "prop-types";
import moment from "moment";
//import { Button } from "_c/button";
//import Confirmable from "_c/Confirmable";
//import { useNotify } from "@/hooks/useNotify";

const ActiveSub = ({ t, ...props }) => {
  //const { notify, notifyError } = useNotify();
  //const [cancelling, setCancelling] = useState(false);
  //const onCancel = async () => {
  //  try {
  //    setCancelling(true);
  //    await props.cancel();
  //    notify(t("premium:cancel_success"));
  //  } catch (e) {
  //    notifyError(t([`errors:${e}`, "errors:unspecified_server"]));
  //  } finally {
  //    setCancelling(false);
  //  }
  //};
  let title;
  if (props.isActive) {
    title = t(`premium:${props.isTrial ? "sub_active_trial" : "sub_active"}`);
    title +=
      " " + t("premium:before") + " " + moment(props.expires).format("L");
  } else {
    title = t("premium:sub_inactive");
  }
  return (
    <S.Wrap>
      <S.Container isActive={props.isActive}>
        <S.IconAndTitle>
          <img src="/images/achieves/premium.png" />
          <S.Title>{title}</S.Title>
        </S.IconAndTitle>
        <div>
          <S.Tip>
            {t(`premium:${props.isActive ? "active_tip" : "inactive_tip"}`)}
          </S.Tip>
        </div>
      </S.Container>
      {/*<Confirmable
        acceptText={t("common:accept")}
        rejectText={t("common:close")}
        onAccept={onCancel}
        title={t("premium:cancel_confirm")}
      >
        <Button disabled={cancelling} small negative>
          {t("premium:cancel_sub")}
        </Button>
      </Confirmable>
      */}
    </S.Wrap>
  );
};
ActiveSub.propTypes = {
  isActive: PT.bool,
  isTrial: PT.bool.isRequired,
  expires: PT.string,

  t: PT.func.isRequired,
  cancel: PT.func,
};

export default ActiveSub;
